import { render, staticRenderFns } from "./ScrollToDiv.vue?vue&type=template&id=3f0d920c&"
import script from "./ScrollToDiv.vue?vue&type=script&lang=js&"
export * from "./ScrollToDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0d920c')) {
      api.createRecord('3f0d920c', component.options)
    } else {
      api.reload('3f0d920c', component.options)
    }
    module.hot.accept("./ScrollToDiv.vue?vue&type=template&id=3f0d920c&", function () {
      api.rerender('3f0d920c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3OSiYSlJQ7X/JS/comp/ScrollToDiv.vue"
export default component.exports